import React from 'react';
import LottiePlayer from "lottie-react";
import NoDataFoundAnim from './nodatafound.json';





const NoDataFound = ({ nodatatext }) => {
    return <div className="no-data-found">

        <div className="textdata d-flex align-items-center justify-content-center flex-column mt-5">
            <LottiePlayer
                animationData={NoDataFoundAnim}
                style={{ height: 150, marginBottom: 0 , border:"none"}}
            />
            <h5 style={{ marginTop: '-10px', fontWeight:"500" , border:"none" }}>{nodatatext}</h5>
        </div>
    </div>
}

export default NoDataFound;
